import RHFDictionary from '../RHFDictionary';
import { useProcurementContracts } from 'iomart-hooks';
import type { Columns } from 'src/@types/common';

const DICTIONARY_COLUMNS: (Columns & { minWidth?: number; maxWidth?: number })[] = [
  {
    name: 'name',
    subname: 'description',
    label: 'Name',
    align: 'left',
    nameLines: 1,
    subNameLines: 1,
    minWidth: 140,
    width: 200,
    maxWidth: 260,
  },
  {
    name: 'supplier',
    subname: 'buyer',
    label: 'Supplier / Buyer',
    format: 'selector',
    subFormat: 'selector',
    params: { selector: (s: any) => s?.name ?? '-' },
    nameLines: 1,
    subNameLines: 1,
    minWidth: 120,
    width: 150,
    maxWidth: 150,
  },
  {
    name: 'currency',
    label: 'Currency',
    align: 'center',
    width: 90,
    minWidth: 80,
    maxWidth: 90,
  },
];

type RHFProcurementContractsProps = {
  name: string;
  label?: string;
  multiple?: boolean;
  disabled?: boolean;
  /** Ширина Drawer справочника */
  drawerWidth?: Record<string, string | number>;
};

export default function RHFProcurementContracts({
  name,
  label = 'Contract',
  multiple = false,
  disabled,
  drawerWidth = { xs: '100%', sm: 560 },
}: RHFProcurementContractsProps) {
  return (
    <RHFDictionary
      name={name}
      label={label}
      useHook={useProcurementContracts}
      columns={DICTIONARY_COLUMNS}
      multiple={multiple}
      optionsLabel="name"
      getOptionLabel={(opt: any) => opt?.name || `#${opt?.id}` || ''}
      searchName="name"
      pageSize={10}
      disabled={disabled}
      filters={{ category: 'active' }}
      drawerWidth={drawerWidth}
    />
  );
}
